"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageContainer = exports.StyledSpinnerContainer = exports.StyledIssueContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIssueContainer = styled_components_1.default.div `
  margin: 1rem 0 1rem;
`;
exports.StyledSpinnerContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`;
exports.StyledPageContainer = styled_components_1.default.div `
  .Polaris-Page {
    background: var(--p-color-bg);
  }
`;
